exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tab-tab-container-2QiZP{display:flex;background-color:rgba(51,77,102,.08);border-radius:8px;margin:0 16px;overflow:hidden;padding:4px}.tab-tab-1jA90{flex:1 1;text-align:center;padding:4px 16px;cursor:pointer;font-family:PingFang SC;font-weight:600;font-size:14px;line-height:20px;color:rgba(0,0,0,.64)}.tab-tab-active-3vmPE{background-color:#fff;color:rgba(0,0,0,.88);border-radius:6px}", ""]);

// Exports
exports.locals = {
	"tab-container": "tab-tab-container-2QiZP",
	"tab": "tab-tab-1jA90",
	"tab-active": "tab-tab-active-3vmPE"
};